export default __webpack_public_path__ + "static/media/horror-zine-spring-2022.f775c0f0.jpg";